import "core-js/modules/es.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Watch, Emit, Prop } from 'vue-property-decorator';
import TreeSelect from '@/components/TreeSelect.vue';
import AllTreeSelect from '@/components/AllTreeSelect.vue';
import apis from '@/apis/caseManage';
import { validateor } from '@/utils/validate';
import { isBoolean } from 'util';
import { clearInterval } from 'timers';

var BaseInfo = /*#__PURE__*/function (_Vue) {
  _inherits(BaseInfo, _Vue);

  var _super = _createSuper(BaseInfo);

  function BaseInfo() {
    var _this;

    _classCallCheck(this, BaseInfo);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic; // 法庭类型

    _this.tribunalType = _this.$store.getters.tribunalType;
    _this.baseInfoForm = {
      caseName: '',
      caseTypeId: '',
      caseTypeName: '',
      caseReasonId: '',
      caseReasonIds: {
        values: [],
        datas: []
      },
      caseReasonName: '',
      caseNoAll: '',
      defaultType: true,
      courtCode: '',
      caseNoYear: '',
      caseNoTypeId: '',
      caseNoNum: '',
      trialProgramNumId: '',
      registerTime: null,
      undertakerDeptId: '',
      undertakerPersonId: _this.$store.getters.userInfo.userId,
      undertakerPersonName: '',
      caseResume: '',
      trialProgramNum: 0,
      trialProgramTypeId: ''
    };
    _this.baseInfoFormRules = {
      defaultType: [],
      caseNoAll: validateor({
        required: true,
        type: 'caseNumber',
        maxLength: 50
      }),
      caseName: validateor({
        required: true,
        type: 'name',
        maxLength: 32
      }),
      caseNoYear: validateor({
        required: true,
        trigger: 'change'
      }),
      caseNoTypeId: validateor({
        required: true,
        trigger: 'change'
      }),
      caseNoNum: validateor({
        required: true,
        type: 'int',
        minValue: 1,
        maxValue: 9999999
      }),
      caseTypeId: validateor({
        required: true,
        trigger: 'change'
      }),
      // caseReasonId: validateor({ required: true }),
      caseReasonIds: validateor({
        required: true
      }),
      registerTime: [{
        type: 'date',
        required: true,
        message: '请选择日期',
        trigger: 'change'
      }],
      undertakerDeptId: validateor({
        required: true
      }),
      undertakerPersonId: validateor({
        required: true,
        trigger: 'change'
      }),
      caseResume: validateor({
        maxLength: 128
      }),
      trialProgramNumId: validateor({
        required: true,
        trigger: 'change'
      })
    }; // 案件类型

    _this.caseTypeIdOptions = [];
    _this.canClearCaseTypeId = false;
    _this.caseTypeIdSelectorProps = {
      label: 'showTypeName',
      isLeaf: 'leaf',
      children: 'children'
    }; // 时间选择限制

    _this.pickerOptions = {
      disabledDate: function disabledDate(time) {
        // return time.getTime() > Date.now();
        return false;
      }
    }; // 案由

    _this.caseReasonIdOptions = []; // 当前案由节点

    _this.currentCaseReasonKey = ''; // 当前案由项目

    _this.currentCaseReasonIds = []; // 案由树

    _this.caseReasonTreeData = [];
    _this.caseReasonIdSelectorProps = {
      id: 'id',
      label: 'caseActionName',
      children: 'children',
      disabled: 'leaf'
    };
    _this.currentCaseReasonIdsProps = {
      name: 'caseActionName',
      value: 'id'
    };
    _this.isCaseReasonIdSelectorLazy = true;
    _this.caseReasonTreeProps = {
      id: 'id',
      label: 'caseActionName',
      isLeaf: 'leaf',
      children: 'children',
      selectable: 'leaf'
    }; // 审判程序

    _this.trialProgramNumIdSelectorProps = {
      label: 'name',
      isLeaf: 'leaf',
      children: 'children',
      selectable: 'selectable'
    }; // 承办部门

    _this.undertakerDeptIdOptions = [];
    _this.undertakerDeptIdSelectorDeptsProps = {
      label: 'label',
      isLeaf: 'hasNext',
      // children: 'children',
      id: 'id'
    }; // 承办人

    _this.undertakerPersonIdOptions = [];
    _this.canClearUndertakerPersonId = false;
    _this.courtCode = ''; // 案由查询控件-树参数缓存

    _this.selectTreeParams = ''; // 案由查询控件-项参数缓存

    _this.selectItemParams = ''; // async created() {
    //   await this.searchCaseReasonTree()
    // }

    return _this;
  } // 案由查询控件


  _createClass(BaseInfo, [{
    key: "initTimer",
    // 为智能搜索的实现加个定时器
    value: function initTimer() {
      var _this2 = this;

      var timer = setInterval(function () {
        // 左侧树智能查询
        var selectTreeParams = _this2.showSelectTreeText;

        if (selectTreeParams !== _this2.selectTreeParams) {
          // console.log(selectTreeParams)
          _this2.searchCaseReasonTree(selectTreeParams);

          _this2.selectTreeParams = selectTreeParams;
        } // 右侧项智能查询


        var selectItemParams = _this2.showSelectItemText;

        if (selectItemParams !== _this2.selectItemParams) {
          // console.log(selectItemParams)
          _this2.$refs.selectTreeOption.optionSearch();

          _this2.selectItemParams = selectItemParams;
        }
      }, 1000);
      this.$once('hook:beforeDestory', function () {
        clearInterval(timer); // timer = null;
      });
    } // @Watch('showSelectTreeText')
    // isSelectItemTreeChange(val) {
    //   console.log('案由树查询', val)
    // }
    // @Watch('showSelectItemText')
    // isSelectItemTextChange(val) {
    //   console.log('案由项查询', val)
    // }
    // 是否为仲裁程序

  }, {
    key: "isArbitrationChange",
    value: function isArbitrationChange(val) {
      var _this3 = this;

      if (val && !this.isEdit) {
        this.baseInfoForm.defaultType = false;
      }

      if (val) {
        apis.caseTypeTree().then(function (res) {
          _this3.caseTypeIdOptions = res.data;
        }).catch(function (_) {
          _this3.caseTypeIdOptions = [];
        });
      }
    } // 获取案件类型选项

  }, {
    key: "getCaseTypeIdOptions",
    value: function getCaseTypeIdOptions(caseCodeId) {
      var _this4 = this;

      // console.log('案件类型切换事件', caseCodeId)
      // 切换是否为默认案号时
      if (isBoolean(caseCodeId)) {
        // 从默认案号切换到非默认案号时
        if (!this.isEdit) {
          this.baseInfoForm.caseTypeId = '';
        }

        if (!caseCodeId) {
          // console.log('非默认案号', caseCodeId)
          apis.caseTypeTree().then(function (res) {
            _this4.caseTypeIdOptions = res.data;
          }).catch(function (_) {
            _this4.caseTypeIdOptions = [];
          });
          return;
        } // 从非默认案号切换到默认案号时，置空案件类型
        // 如果存在caseNoTypeId，请求案件类型选项


        this.baseInfoForm.caseTypeId = '';

        if (!this.baseInfoForm.caseNoTypeId) {
          this.caseTypeIdOptions = [];
          return;
        }

        apis.caseTypes({
          caseCodeId: this.baseInfoForm.caseNoTypeId
        }).then(function (res) {
          _this4.caseTypeIdOptions = res.data || [];
        }).catch(function (_) {
          _this4.caseTypeIdOptions = [];
        });
        return;
      } // 修改案件代号时
      // 第一次修改案件代号不置空案件类型


      if (this.canClearCaseTypeId) {
        this.baseInfoForm.caseTypeId = '';
      }

      this.canClearCaseTypeId = true; // 请求案件类型选项

      apis.caseTypes({
        caseCodeId: this.baseInfoForm.caseNoTypeId
      }).then(function (res) {
        _this4.caseTypeIdOptions = res.data;
      }).catch(function (_) {
        _this4.caseTypeIdOptions = [];
      });
    } // 处理案由树节点点击事件

  }, {
    key: "handleCaseReasonClick",
    value: function handleCaseReasonClick(val) {
      var _this5 = this;

      // console.log('处理案由树节点点击事件', val)
      apis.caseSubItem({
        id: val.no
      }).then(function (res) {
        _this5.currentCaseReasonIds = res.data;
      }).catch(function (_) {
        _this5.currentCaseReasonIds = [];
      });
    } // load 案由

  }, {
    key: "loadCaseReasonIdOptions",
    value: function () {
      var _loadCaseReasonIdOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(node, resolve) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(node.level === 0)) {
                  _context.next = 8;
                  break;
                }

                _context.t0 = resolve;
                _context.next = 4;
                return this.getCaseReasonTree(null);

              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 13;
                break;

              case 8:
                _context.t2 = resolve;
                _context.next = 11;
                return this.getCaseReasonTree(node.data.id);

              case 11:
                _context.t3 = _context.sent;
                (0, _context.t2)(_context.t3);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadCaseReasonIdOptions(_x, _x2) {
        return _loadCaseReasonIdOptions.apply(this, arguments);
      }

      return loadCaseReasonIdOptions;
    }() // 查询案由

  }, {
    key: "searchCaseReasonIdOptions",
    value: function searchCaseReasonIdOptions(caseActionName) {
      this.isCaseReasonIdSelectorLazy = false;
      this.getCaseReasonIdOptionsBySearch(caseActionName);
    } // 案由select回调

  }, {
    key: "selectCaseReason",
    value: function selectCaseReason(node) {
      this.baseInfoForm.caseReasonName = node.caseActionName;
    } // 清空案由查询

  }, {
    key: "clearSearchCaseReasonIdOptions",
    value: function () {
      var _clearSearchCaseReasonIdOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isCaseReasonIdSelectorLazy = true;
                _context2.next = 3;
                return this.getCaseReasonTree(null);

              case 3:
                this.caseReasonIdOptions = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function clearSearchCaseReasonIdOptions() {
        return _clearSearchCaseReasonIdOptions.apply(this, arguments);
      }

      return clearSearchCaseReasonIdOptions;
    }() // 案由异步树 根据父节点id获取子节点

  }, {
    key: "getCaseReasonTree",
    value: function getCaseReasonTree(parentId) {
      return apis.caseActionByParentId({
        parentId: parentId
      }).then(function (res) {
        return res.data;
      }).catch(function (_) {
        return [];
      });
    } // 案由同步树 根据查询获取整个案由树

  }, {
    key: "getCaseReasonIdOptionsBySearch",
    value: function getCaseReasonIdOptionsBySearch(caseActionName) {
      var _this6 = this;

      apis.caseActionTree({
        caseActionName: caseActionName
      }).then(function (res) {
        // console.log('条件查询结果', res.data)
        _this6.caseReasonIdOptions = res.data || [];
      }).catch(function (_) {
        _this6.caseReasonIdOptions = [];
      });
    } // 案由同步树 初始化案由树

  }, {
    key: "searchCaseReasonTree",
    value: function searchCaseReasonTree() {
      var _this7 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var caseActionName = val || '%';
      apis.caseActionTreeNoLeaf({
        caseActionName: caseActionName
      }).then(function (res) {
        // console.log('初始化案由树', res.data)
        _this7.caseReasonTreeData = res.data || [];
      }).catch(function (_) {
        _this7.caseReasonTreeData = [];
      });
    } // load 审判程序

  }, {
    key: "loadTrialProgramNumIdOptions",
    value: function () {
      var _loadTrialProgramNumIdOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(node, resolve) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(node.level === 0)) {
                  _context3.next = 8;
                  break;
                }

                _context3.t0 = resolve;
                _context3.next = 4;
                return this.getTrialProgramTree(null);

              case 4:
                _context3.t1 = _context3.sent;
                (0, _context3.t0)(_context3.t1);
                _context3.next = 13;
                break;

              case 8:
                _context3.t2 = resolve;
                _context3.next = 11;
                return this.getTrialProgramTree(node.data.id);

              case 11:
                _context3.t3 = _context3.sent;
                (0, _context3.t2)(_context3.t3);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadTrialProgramNumIdOptions(_x3, _x4) {
        return _loadTrialProgramNumIdOptions.apply(this, arguments);
      }

      return loadTrialProgramNumIdOptions;
    }() // 审判程序异步树 根据父节点id获取子节点

  }, {
    key: "getTrialProgramTree",
    value: function getTrialProgramTree(parentId) {
      return apis.trialProgramTree({
        parentId: parentId
      }).then(function (res) {
        return res.data;
      }).catch(function (_) {
        return [];
      });
    }
  }, {
    key: "trialProgramTreeChange",
    value: function trialProgramTreeChange(node) {
      // 审判程序change回调
      this.baseInfoForm.trialProgramTypeId = node.parentId;
      this.baseInfoForm.trialProgramNum = node.programType;
    } // 获取承办部门同步树

  }, {
    key: "getUndertakerDeptIdOptions",
    value: function getUndertakerDeptIdOptions() {
      var _this8 = this;

      apis.deptByIndexCode().then(function (res) {
        _this8.undertakerDeptIdOptions = res.data;
      });
    } // 获取承办人选项

  }, {
    key: "getUndertakerPersonIdOptions",
    value: function getUndertakerPersonIdOptions(deptIndexCode) {
      var _this9 = this;

      // 第一次修改承办部门不置空承办人
      if (this.canClearUndertakerPersonId) {
        this.baseInfoForm.undertakerPersonId = '';
      }

      this.canClearUndertakerPersonId = true;
      apis.usersInDept({
        deptIndexCode: deptIndexCode
      }).then(function (res) {
        _this9.undertakerPersonIdOptions = res.data;
      }).catch(function (_) {
        _this9.undertakerPersonIdOptions = [];
      });
    }
  }, {
    key: "handleTrialProgramChange",
    value: function handleTrialProgramChange(parentId) {
      return parentId;
    }
  }, {
    key: "handleUndertakerPersonChange",
    value: function handleUndertakerPersonChange(id) {
      var item = this.undertakerPersonIdOptions.find(function (i) {
        return i.id === id;
      });

      if (item !== undefined) {
        this.baseInfoForm.undertakerPersonName = item.reallyName;
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (valid) {};
      // console.log('选择的案由:', this.baseInfoForm.caseReasonIds)
      var baseInfoFormRef = this.$refs.baseInfoForm;
      baseInfoFormRef.validate(function (valid) {
        callback(valid);
        baseInfoFormRef.focusFirstField();
      });
    } // 获取用户所在法院的信息

  }, {
    key: "getCourt",
    value: function getCourt() {
      var _this10 = this;

      apis.court().then(function (res) {
        _this10.baseInfoForm.courtCode = res.data.courtCode || ''; // TODO deptId 是啥

        _this10.baseInfoForm.undertakerDeptId = res.data.deptId || '';
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      // 新建时，获取用户所在法院信息
      if (!this.isEdit) {
        this.getCourt();
        if (this.isArbitration) this.baseInfoForm.defaultType = false;
      }

      this.initTimer();
      this.searchCaseReasonTree();
      this.getUndertakerDeptIdOptions();
    }
  }, {
    key: "showSelectTreeOption",
    get: function get() {
      return this.$refs.selectTreeOption;
    } // 案由查询控件-案由树查询条件

  }, {
    key: "showSelectTreeText",
    get: function get() {
      try {
        return this.$refs.selectTreeOption.treeText;
      } catch (e) {
        console.log(e);
        return '';
      }
    } // 案由查询控件-案由项查询条件

  }, {
    key: "showSelectItemText",
    get: function get() {
      try {
        return this.$refs.selectTreeOption.optionText;
      } catch (e) {
        console.log(e);
        return '';
      }
    }
  }, {
    key: "isArbitration",
    get: function get() {
      return this.$store.getters.tribunalType === 'arbitration';
    } // 审判程序不可编辑判断条件

  }, {
    key: "editDisable",
    get: function get() {
      if (this.isEdit) return true;
      return false;
    }
  }]);

  return BaseInfo;
}(Vue);

__decorate([Prop({
  type: Boolean
})], BaseInfo.prototype, "isEdit", void 0);

__decorate([Watch('isArbitration')], BaseInfo.prototype, "isArbitrationChange", null);

__decorate([Watch('baseInfoForm.undertakerDeptId')], BaseInfo.prototype, "getUndertakerPersonIdOptions", null);

__decorate([Watch('baseInfoForm.trialProgramNumId'), Emit('trialProgramChange')], BaseInfo.prototype, "handleTrialProgramChange", null);

BaseInfo = __decorate([Component({
  components: {
    TreeSelect: TreeSelect,
    AllTreeSelect: AllTreeSelect
  }
})], BaseInfo);
export default BaseInfo;